/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'feedback-collector.anonymous': 'Этот отзыв будет отправлен анонимно. Сотрудники Atlassian не смогут связаться с вами напрямую по поводу этого отзыва',
  'feedback-collector.anonymous.title': 'Анонимный отзыв',
  'feedback-collector.can-be-contacted.label': 'Да, команды Atlassian могут связаться со мной, чтобы узнать о моих впечатлениях и использовать эту информацию для улучшения продуктов и услуг Atlassian. Я соглашаюсь с <a>Политикой конфиденциальности Atlassian</a>.',
  'feedback-collector.cancel-button.label': 'Отмена',
  'feedback-collector.default.custom.textarea.label': 'Поделитесь своими мыслями.',
  'feedback-collector.enrol-in-research.label': 'Я хочу принять участие в исследовании продукта',
  'feedback-collector.feedback-title': 'Напишите отзыв',
  'feedback-collector.form.bug.label': 'Опишите баг или проблему',
  'feedback-collector.form.comment.label': 'Поделитесь своими мыслями',
  'feedback-collector.form.empty.label': 'Выбрать опцию',
  'feedback-collector.form.question.label': 'О чем бы вы хотели знать?',
  'feedback-collector.form.suggestion.label': 'Расскажите, что бы вы хотели улучшить',
  'feedback-collector.option.bug.label': 'Сообщить о баге',
  'feedback-collector.option.comment.label': 'Оставить комментарий',
  'feedback-collector.option.default.label': 'Выберите отзыв',
  'feedback-collector.option.default.placeholder': 'Выберите отзыв',
  'feedback-collector.option.question.label': 'Задать вопрос',
  'feedback-collector.option.suggestion.label': 'Предложить улучшение',
  'feedback-collector.required.fields.summary': 'Обязательные поля отмечены звездочкой',
  'feedback-collector.submit-button.label': 'Отправить отзыв',
  'feedback-collector.success-flag.description': 'Ваши отзывы помогают нам постоянно улучшать качество продуктов.',
  'feedback-collector.success-flag.title': 'Спасибо!',
  'feedback-collector.summary-placeholder': 'Поделитесь своими мыслями',
  'proforma-form-builder.feedback-icon-label': 'Отзыв',
  'proforma-form-builder.give-feedback': 'Оставить отзыв'
};